import './split-accordion.scss';

/**
 * version    1.0
 * class      <type> (split accordion)
 * classdesc  Component that manage split accordion component
 */
export class SplitAccordion {}
